export default "__VITE_ASSET__BsFRReSu__"